module.exports = __webpack_public_path__ + "static/img/kiss.9897cef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/kiss.jpg
// module id = 193n
// module chunks = 1